import { useTranslation } from 'react-i18next';
import { LiliButton } from '@lili/lili-frontend-common';
import { STYLE, TEXT } from '../../constants';

const { PAGES: { POST_LINKED: { MONEY_TRANSFER } } } = STYLE;
const { PAGES: { POST_LINKED: { MONEY_TRANSFER: { FOOTER } } } } = TEXT;

interface IProps {
    onSubmit: () => void;
    isTransfer: boolean;
    isLoading: boolean;
}

export const TransferFooter = ({ onSubmit, isTransfer, isLoading }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className={MONEY_TRANSFER.FOOTER.WRAPPER}>
      <LiliButton isLoading={isLoading} disabled={!isTransfer || isLoading} onClick={onSubmit} className={MONEY_TRANSFER.FOOTER.CTA} id='transfer-cta' title={t(FOOTER.CTA_TITLE)} />
      <p className={MONEY_TRANSFER.FOOTER.CONTENT}>
        {t(FOOTER.CONTENT)}
      </p>
    </div>
  );
};
